<bcu-local-spinner [size]="40" [visible]="(courtClass$ | async).isLoading" *ngIf="(courtClass$ | async).isLoading">
</bcu-local-spinner>
<div class="container  my-3" *ngIf="(courtClass$ | async).loaded && (courtClass$ | async).data as courtClass">
    <div class="row card shadow p-4 border-bottom no-gutters color-dark-gray-bg text-white">
        <div class="col">
            <div class="row no-gutters py-2 px-3">
                <div class="col-5">
                    <div class="font-weight-bold"><h3>{{courtClass.name}}</h3></div>
                    <div>{{'CourtEventDetails.CourtClassDetailsName' | translate}}</div>
                </div>
                <div class="col-3"></div>
                <div class="col-4 m-0 text-right">
                    <a class="btn btn-light" target="_blank" href="{{ groupClassesUrl() }}"> {{'CourtEventDetails.CourtClassOpenBtn' | translate}}</a>
                </div>
            </div>
            <div class="row no-gutters px-3">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>
            <div class="row no-gutters py-2 px-3">
                <div class="col text-left">
                    <span class="ic_bs_calendar mr-2"></span> {{courtClass.date | bcDate: 'dddd'}}, {{courtClass.date | bcDate: 'MMM Do YY'}}
                </div>                    
                <div class="col text-left">
                    <span class="ic-cb-time mr-2"></span>
                    {{courtClass.timeFromInMinutes | timeDisplay : true}} -
                    {{courtClass.timeToInMinutes | timeDisplay}}
                </div>
                <div class="col text-left">
                    <span class="ic_bs_court mr-2"></span>
                    {{courtClass.court.name}} <span *ngIf="courtClass.court.tennisType">({{courtClass.court.tennisType.name}})</span>
                </div>
                <div class="col text-left">
                    <app-court-event-status-pill [status]="courtClass.status"></app-court-event-status-pill>
                </div>
                <div class="col">
                </div>
            </div>
            <div class="row no-gutters py-2 px-3">
                <div class="col-auto text-left">
                    <span class="ic-person mr-2"></span>
                </div>
                <div class="col-2 text-md-left">
                    <div *ngIf="!courtClass.substituteInstructor && courtClass.instructor">{{courtClass.instructor.name}}</div>
                    <div *ngIf="courtClass.substituteInstructor">{{courtClass.substituteInstructor.name}}</div>
                </div>
                <div class="col">
                </div>
            </div>

            <div class="row no-gutters px-3" *ngIf="isAnyNote(courtClass)">
                <div class="col-12">
                    <hr class="solid bg-white"/>
                </div>                    
            </div>

            <div class="py-2 px-3" *ngIf="isAnyNote(courtClass)">
                <app-court-event-notes-details [notes]="courtClass.notes"></app-court-event-notes-details>
            </div>

            <div class="row no-gutters pt-2 px-3">
                <div class="col">
                    <span class="clickable" (click)="onAddNote()">{{'CourtEventDetails.AddNote' | translate}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="card mt-4" *ngIf="courtClass.timelineItems.length">        
        <app-court-event-timeline [timelines]="courtClass.timelineItems"></app-court-event-timeline>        
    </div>
</div>
